import { MeshBasicMaterial, LineBasicMaterial, LineDashedMaterial, DoubleSide, Color } from 'three';

export const lilacMaterial = new MeshBasicMaterial({ color: 0xBD9ECD });
export const yellowMaterial=new MeshBasicMaterial({ color: 0xE8FF50 });
export const lineMeshMaterial=new MeshBasicMaterial({ color: 0xC91717 });
export const lineMaterial=new LineBasicMaterial({ color:0x71E885 });
export const dashedLineMaterial=new LineDashedMaterial ({
    color: 0x0000ff,
    linewidth: 1,
    scale: 1,
    dashSize: 0.5,
    gapSize: 0.3,
});
export const planeMaterial = new MeshBasicMaterial({ color: 0xC2C9F5, side: DoubleSide, transparent: true, opacity: 0.7 });

export const defaultTextColor = new Color(0x080808);
export const textMaterial = new MeshBasicMaterial(
    { color: 0x080808, depthTest: false },
);
